module.exports = __webpack_public_path__ + "static/media/registro-visitantes.d9e2a82c.jpeg";